// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightOsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/os/preflight
 * (controllers/migration/os.php::preflight).
 *
 * Uma linha por OS da franquia DENTRO DO PERIODO pedido, com o de-para ja
 * executado. Leitura pura — nada foi escrito para montar isto.
 *
 * O periodo e ecoado de volta (`data_ini`/`data_fim`) porque a tela precisa
 * mostrar QUAL recorte produziu estes numeros: "1.204 OS" sem o periodo ao
 * lado e um numero que o operador nao consegue conferir. Sem recorte os dois
 * vem null, e ai a lista e a franquia inteira.
 */
import type { Migration_PreflightOsRow } from './Migration_PreflightOsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightOsResponseDados {
registros: Migration_PreflightOsRow[]
data_ini?: string
data_fim?: string
}

export type Migration_PreflightOsResponse = ApiResponse<Migration_PreflightOsResponseDados>;

registerResponseContract('Migration_PreflightOsResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:              { type: 'string',  required: false },
      os_numero:            { type: 'number',  required: false },
      nome_cliente:         { type: 'string',  required: false },
      status:               { type: 'string',  required: false },
      status_zoho:          { type: 'string',  required: false },
      valor_final_centavos: { type: 'number',  required: false },
      criado_em:            { type: 'string',  required: false },
      n_itens:              { type: 'number',  required: false },
      ja_migrado:           { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
  data_ini:  { type: 'string',  required: false },
  data_fim:  { type: 'string',  required: false },
})
